var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFertSoluble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9896 22.2308H1.46697C0.658109 22.2308 0 22.8154 0 23.5331V24.1849C0 24.904 0.658109 25.4886 1.46697 25.4886H22.4706C24.6218 29.0079 28.8372 31.1417 33.3483 30.9927C39.2988 30.9927 44.2114 27.6882 44.9739 23.3986C45.0074 23.2619 45.0078 23.1191 44.975 22.9822C44.9422 22.8454 44.8772 22.7185 44.7855 22.6123C44.6848 22.4983 44.5626 22.4058 44.4259 22.3403C44.2892 22.2748 44.1408 22.2376 43.9896 22.2308ZM44.065 20.0678L39.9294 13.5026C39.6192 13.0086 39.0364 12.7017 38.4088 12.7017H37.6564C37.1926 12.7017 36.7374 12.6228 36.3083 12.4664L35.8734 12.3086C35.4197 12.1434 33.2323 12.0002 33.2323 12.0002C32.9895 11.9965 32.7494 12.0526 32.5329 12.1637C32.3164 12.2747 32.1301 12.4373 31.99 12.6374L31.2507 13.754H30.065C29.6098 13.754 29.1807 13.9542 28.9169 14.2904L27.8326 15.6642C27.6916 15.8369 27.5139 15.9755 27.3127 16.0699C27.1115 16.1642 26.8919 16.2119 26.6701 16.2094C25.9119 16.2094 25.2161 16.5557 24.8117 17.136L22.7533 20.0678H22.1938C21.9792 20.0678 21.8067 20.2242 21.8067 20.4185C21.8067 20.6129 21.9807 20.7693 22.1938 20.7693H44.613C44.8275 20.7693 45 20.6129 45 20.4185C45 20.2242 44.826 20.0678 44.613 20.0678H44.065Z",
    fill: "#9CCE6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFertSoluble);
export default __webpack_public_path__ + "static/media/ic-fert-soluble.4c165202b38c3f15dea781a677d14d50.svg";
export { ForwardRef as ReactComponent };